import { Fragment } from 'react';
import { CircularProgress } from '@mui/material';

import SetupProcess from './SetupProgress';
import TeamOverviewList from './TeamOverviewList';
import SystemAlerts from './SystemAlerts';
import StatisticsCard from '../../../../../components/statistics/StatisitcsCard';
import RegistrationOverview from './RegistrationOverview';
import InvitationOverview from './InvitationOverview';
import TicketInventory from './TicketInventory';
import ScheduleOverview from './ScheduleOverview';
import AlertDialog from '../../../../../components/Dialog/AlertDialog';
import RevenueGenerated from './RevenueGenerated';
import SalesSummary from './SalesSummary';

import useEventDashboardTab from './hooks/useEventDashboardTab';
import useEvent from '../../../../../hooks/event-hooks/useEvent';

import { Body1 } from '../../../../../themes/typography';
import "../../../../../styles/event/EventDashboardTab.css";

function EventDashboard() {

    const {
        onManageTeam,
        checkInStaff,
        tickets,
        onNewTicketTypeAdd,
        anchorEl,
        open,
        onElipsisClick,
        onElipsisClose,
        menusList,
        loading,
        openModal,
        modalVariant,
        onModalClose,
        onDeleteTicket,
        onEndSaleTicket,
        onMarkAsSoldOutTicket,
        showBackdrop,
        onViewAllAttendees,
        attendees,
        invitations,
        onViewAllInvitations,
        stats,
        eventData,
        progress,
        timeframe,
        onTimeframeChange,
        toggleChart,
        showTicketSoldChart,
        showRevenueGeneratedChart,
        onShowTicketSoldChart,
        onShowRevenueGeneratedChart,
        onShowTotalRevenueChart,
        showTotalRevenueChart,
        currentDataset,
        revenueGeneratedData,
    } = useEventDashboardTab();

    const { isEventPublishedOnce, isScheduleCompleted } = useEvent();

    return (
        <Fragment>
            <div className='event-specific-dashboard-tab'>

                <div className='event-specific-dashboard-tab-wrapper'>

                    {progress < 100 && (
                        <div className='event-setup-container'>
                            <SetupProcess />
                        </div>
                    )}

                    <div className='event-system-alert-with-schedule'>
                        <SystemAlerts />

                        {isScheduleCompleted && (
                            <ScheduleOverview
                                eventType={eventData?.event_type}
                                schedule={eventData?.schedules}
                            />
                        )}
                    </div>

                    {isEventPublishedOnce && (
                        <div className='event-stats-container'>
                            {stats.map((stat, index) => (
                                <StatisticsCard
                                    key={index}
                                    name={stat.label}
                                    value={stat.value}
                                />
                            ))}
                        </div>
                    )}

                    {isEventPublishedOnce && (
                        <div className='event-sales-chart-container'>
                            <SalesSummary
                                timeframe={timeframe}
                                onTimeFrameChange={onTimeframeChange}
                                toggleChart={toggleChart}
                                showTicketSoldChart={showTicketSoldChart}
                                showTotalRevenueChart={showTotalRevenueChart}
                                showRevenueGeneratedChart={showRevenueGeneratedChart}
                                onShowTicketSoldChart={onShowTicketSoldChart}
                                onShowRevenueGeneratedChart={onShowRevenueGeneratedChart}
                                dataset={currentDataset}
                                onShowTotalRevenueChart={onShowTotalRevenueChart}
                            />
                        </div>
                    )}


                    {isEventPublishedOnce && (
                        <div className='event-ticket-inventory-with-chart'>
                            <TicketInventory
                                data={tickets}
                                onNewTicketTypeAdd={onNewTicketTypeAdd}
                                menusList={menusList}
                                anchorEl={anchorEl}
                                open={open}
                                onElipsisClick={onElipsisClick}
                                onElipsisClose={onElipsisClose}
                            />

                            <RevenueGenerated
                                data={revenueGeneratedData}
                            />
                        </div>
                    )}


                    {isEventPublishedOnce && (
                        <div className='event-invitations-with-attendance'>
                            <InvitationOverview
                                data={invitations}
                                onViewAllInvitations={onViewAllInvitations}
                            />
                            <RegistrationOverview
                                data={attendees}
                                onViewAllAttendees={onViewAllAttendees}
                            />
                        </div>
                    )}

                    {isEventPublishedOnce && (
                        <div className='event-team-overview'>
                            <TeamOverviewList
                                onManageTeam={onManageTeam}
                                totalStaffAdded={checkInStaff?.length}
                            />
                        </div>
                    )}

                </div>

            </div>
            <AlertDialog
                dialogId='ticket-inventory-actions'
                open={openModal}
                onCancel={onModalClose}
                onConfirm={
                    modalVariant === 'deleteTicket' ? onDeleteTicket :
                        modalVariant === 'endSale' ? onEndSaleTicket :
                            modalVariant === 'markAsSoldOut' ? onMarkAsSoldOutTicket :
                                null
                }
                dialogTitle={
                    modalVariant === 'deleteTicket' ? 'Delete Ticket' :
                        modalVariant === 'endSale' ? 'End Ticket Sale' :
                            modalVariant === 'markAsSoldOut' ? 'Mark Ticket as Sold Out' :
                                'Cannot Delete Ticket'
                }
                primaryBtnName={
                    modalVariant === 'deleteTicket' ? 'Delete' :
                        modalVariant === 'endSale' ? 'End Sale' :
                            modalVariant === 'markAsSoldOut' ? 'Mark as Sold Out' :
                                'Delete'
                }
                secondaryBtnName="Cancel"
                loading={loading}
                disabled={loading || modalVariant === 'cannotDelete'}
            >

                {modalVariant === 'deleteTicket' && (
                    <Body1>Are you sure you want to delete this ticket? This action cannot be undone.</Body1>
                )}

                {modalVariant === 'endSale' && (
                    <Body1>Are you sure you want to end the sale for this ticket? Attendees will no longer be able to purchase it.</Body1>
                )}

                {modalVariant === 'markAsSoldOut' && (
                    <Body1>Are you sure you want to mark this ticket as sold out? It will no longer be available for purchase.</Body1>
                )}

                {modalVariant === 'cannotDelete' && (
                    <Body1>This ticket cannot be deleted because there are already sales associated with it. Please contact support for further assistance.</Body1>
                )}

            </AlertDialog>

            {showBackdrop && (
                <div className="fullscreen-loader">
                    <CircularProgress color="inherit" />
                </div>
            )}

        </Fragment>
    );
}

export default EventDashboard;